<!-- @author Amol, @date 29-08-2021, @description added assign batch plant company popup component-->
<div class="mainContent">

    <div style="height: 7vh;">
      <div>
        <label i18n="@@spmsUserReg" class="textColour" >Migration Configration </label>
        <span class="example-spacer"></span>
      </div>
    </div>

    <form #migrationForm="ngForm" (ngSubmit)="onSubmit(migrationForm)">
      <!-- Run Id -->
      <!-- <mat-form-field appearance="outline">
        <mat-label>Run Id</mat-label>
        <input matInput type="number" placeholder="Run Id" [(ngModel)]="inputValue" name="inputValue" #inputValueCtrl="ngModel"  min="1" required>
        <mat-error *ngIf="submitted && inputValueCtrl.errors?.required">Run Id is required</mat-error>
        <mat-error *ngIf="(submitted && inputValueCtrl.touched) && inputValueCtrl.errors?.min">Value must be greater than 0</mat-error>
      </mat-form-field> -->
      <mat-form-field appearance="outline">
        <mat-label>Run Id</mat-label>
        <input
          matInput
          type="number"
          placeholder="Run Id"
          [(ngModel)]="inputValue"
          name="inputValue"
          #inputValueCtrl="ngModel"
          min="1"
          required
        />
        <mat-error *ngIf="inputValueCtrl.invalid && (submitted || inputValueCtrl.dirty || inputValueCtrl.touched)">
          <span *ngIf="inputValueCtrl.errors?.required">Run Id is required</span>
          <span *ngIf="inputValueCtrl.errors?.min">Value must be greater than 0</span>
        </mat-error>
      </mat-form-field>
      <!-- <mat-form-field appearance="outline">
        <mat-label>Run Id</mat-label>
        <input
          matInput
          type="number"
          placeholder="Run Id"
          [(ngModel)]="inputValue"
          name="inputValue"
          #inputValueCtrl="ngModel"
          min="1"
          required
        />
        <mat-error *ngIf="inputValueCtrl.invalid && (inputValueCtrl.dirty || inputValueCtrl.touched || submitted)">
          <span *ngIf="inputValueCtrl.errors?.required">Run Id is required</span>
          <span *ngIf="inputValueCtrl.errors?.min">Value must be greater than 0</span>
        </mat-error>
      </mat-form-field> -->
      
      <!-- Global Extraction Duration -->
      <!-- <mat-form-field appearance="outline">
        <mat-label>Global Extraction Duration (minutes)</mat-label>
        <input matInput type="number" placeholder="Global Extraction Duration" [(ngModel)]="GlobalExtraction" name="GlobalExtraction" #GlobalExtractionCtrl="ngModel" min="1" required>
        <mat-error *ngIf="submitted && GlobalExtractionCtrl.errors?.required">This field is required</mat-error>
        <mat-error *ngIf="submitted && GlobalExtractionCtrl.errors?.min">Value must be greater than 0</mat-error>
      </mat-form-field> -->
      <mat-form-field appearance="outline">
        <mat-label>Global Extraction Duration (minutes)</mat-label>
        <input
          matInput
          type="number"
          placeholder="Global Extraction Duration"
          [(ngModel)]="GlobalExtraction"
          name="GlobalExtraction"
          #GlobalExtractionCtrl="ngModel"
          min="1"
          required
        />
        <mat-error *ngIf="GlobalExtractionCtrl.invalid && (submitted || GlobalExtractionCtrl.dirty || GlobalExtractionCtrl.touched)">
          <span *ngIf="GlobalExtractionCtrl.errors?.required">GlobalExtraction Duration is required</span>
          <span *ngIf="GlobalExtractionCtrl.errors?.min">Value must be greater than 0</span>
        </mat-error>
      </mat-form-field>
      <!-- Extraction Duration -->
      <mat-form-field appearance="outline">
        <mat-label>Extraction Duration (minutes)</mat-label>
        <input matInput type="number" placeholder="Extraction Duration" [(ngModel)]="Extraction" name="Extraction" #ExtractionCtrl="ngModel"  min="1" required>
        <!-- <mat-error *ngIf="submitted && ExtractionCtrl.errors?.required">This field is required</mat-error>
        <mat-error *ngIf="submitted && ExtractionCtrl.errors?.min">Value must be greater than 0</mat-error> -->
        <mat-error *ngIf="ExtractionCtrl.invalid && (submitted || ExtractionCtrl.dirty || ExtractionCtrl.touched)">
          <span *ngIf="ExtractionCtrl.errors?.required">Extraction Duration is required</span>
          <span *ngIf="ExtractionCtrl.errors?.min">Value must be greater than 0</span>
        </mat-error>
      </mat-form-field>
    
      <!-- Transformation Duration -->
      <mat-form-field appearance="outline">
        <mat-label>Transformation Duration (minutes)</mat-label>
        <input
          matInput
          type="number"
          placeholder="Transformation Duration"
          [(ngModel)]="Transform"
          name="Transform"
          #TransformCtrl="ngModel"
          min="1"
          required
        />
        <mat-error *ngIf="TransformCtrl.invalid && (submitted || TransformCtrl.dirty || TransformCtrl.touched)">
          <span *ngIf="TransformCtrl.errors?.required">Transformation Duration is required</span>
          <span *ngIf="TransformCtrl.errors?.min">Value must be greater than 0</span>
        </mat-error>
      </mat-form-field>
      
      <!-- Load Duration -->
      <mat-form-field appearance="outline">
        <mat-label>Load Duration (minutes)</mat-label>
        <input
          matInput
          type="number"
          placeholder="Load Duration"
          [(ngModel)]="Load"
          name="Load"
          #LoadCtrl="ngModel"
          min="1"
          required
        />
        <mat-error *ngIf="LoadCtrl.invalid && (submitted || LoadCtrl.dirty || LoadCtrl.touched)">
          <span *ngIf="LoadCtrl.errors?.required">Load Duration is required</span>
          <span *ngIf="LoadCtrl.errors?.min">Value must be greater than 0</span>
        </mat-error>
      </mat-form-field>
      
      <!-- Validation Duration -->
      <mat-form-field appearance="outline">
        <mat-label>Validation Duration (minutes)</mat-label>
        <input
          matInput
          type="number"
          placeholder="Validation Duration"
          [(ngModel)]="Validation"
          name="Validation"
          #ValidationCtrl="ngModel"
          min="1"
          required
        />
        <mat-error *ngIf="ValidationCtrl.invalid && (submitted || ValidationCtrl.dirty || ValidationCtrl.touched)">
          <span *ngIf="ValidationCtrl.errors?.required">Validation Duration is required</span>
          <span *ngIf="ValidationCtrl.errors?.min">Value must be greater than 0</span>
        </mat-error>
      </mat-form-field>
    
      <div style="height:5vh">
        <div class="row" style="position:sticky;left:0;bottom:0;width:100%;">
          <div class="col-lg text-center">
            <div style="text-align: end;">

             
              <mat-checkbox  *ngIf="isAddingRecord" [(ngModel)]="isCheckboxSelected" name="anotherCheckbox" style="margin-right:1%" class="mat-checkbox-layout" id="isCheckboxSelected">
              <span id="checkboxSpan">Create another</span>
            </mat-checkbox>
              
              <!-- <button i18n="@@TargetClear" type="button" (click)="onSubmit(migrationForm)"
                      class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton"
                      style="padding: .3rem 1.6rem;font-size: .85rem;width:95px;color: white;" [innerText]="buttonText" id="updateDataButton"></button> -->
                     
                     
                     
                      <button i18n="@@TargetClear" type="button" (click)="onSubmit(migrationForm)"
                      class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton"
                      style="padding: .3rem 1.6rem;width:110px;font-size: .85rem;color: white;" [innerText]="buttonText"></button>



                      <button i18n="@@TargetCancel" type="button" (click)="close()"
                      class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                      [style.background-color]="backgroundColorButton2"
                      [style.border-color]="backgroundColorButton"
                      style="padding: .3rem 1.6rem; width: 110px; font-size: .85rem; color: black; border: 1px solid #0a88c5;"
                      id="cancelButton">
                      Cancel
                    </button>
                   
            </div>
          </div>
        </div>
      </div>
    </form>
    